// hooks/useReportData.js
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getRedirectReport } from '../../../../redux/actions/redirectPortal/redirectPortal_reportAction';

export const useReportData = (fromDate, toDate, filters) => {
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchReportData();
  }, [dispatch, fromDate, toDate]);

  const fetchReportData = () => {
    const data = JSON.stringify({
      from_date: fromDate ? fromDate.format("YYYY-MM-DD HH:mm") : "",
      to_date: toDate ? toDate.format("YYYY-MM-DD HH:mm") : "",
    });
    dispatch(getRedirectReport(data));
  };

  useEffect(() => {
    if (state?.getRedirectReport?.RedirectReport?.data) {
      const formattedRows = state.getRedirectReport.RedirectReport.data.map((item, index) => ({
        id: index + 1,
        did_tfn: item.did_number,
        buyer_name: item.buyer_name,
        uniqueid: item.uniqueid,
        caller_id_number: item.src,
        user_uuid: item?.user_uuid,
        call_direction: item?.call_direction,
        disposition: item?.disposition,
        duration: item?.duration,
        billsec: item?.billsec,
        answer_at: item.answer_at,
        time: item.answer_at,
        end_at: item.end_at,
        start_at: item.start_at,
        start_time: item.start_at,
        recording_path: item.recording_path,
        hangup_reason: item.status,
        campaign_name: item.campaign_name,
        destination: item.destination,
        username: item.username,
        answered_by: item.answered_by,
        transfered_to: item.transfered_to,
        forwarded_number: item.forwarded_number,
        hangupby: item.hangupby,
        call_result: item.call_result,
      }));
      setRows(formattedRows);
    }
  }, [state?.getRedirectReport]);

  const search = () => {
    const data = JSON.stringify({
      from_date: fromDate ? fromDate.format("YYYY-MM-DD HH:mm") : "",
      to_date: toDate ? toDate.format("YYYY-MM-DD HH:mm") : "",
      call_direction: filters.callDirection,
      did_number: filters.didNumber,
      forward_number: filters.destination,
      caller_id: filters.callerId,
      hangup_reason: filters.status,
    });
    dispatch(getRedirectReport(data));
  };

  return {
    rows,
    loading: state?.getRedirectReport?.loading || false,
    search,
    buyerDialogs: state?.allManageBuyerDialog?.buyerDialog?.data || [],
  };
};